module.exports = {
  title: 'FriendFormant',
  description: `
    FriendFormant is a website that was developed with a friend, Greg Curiel, which using the Facebook API compares a user’s friends
    to a previous version of their friends to give them details on people who have removed or added them. Due to API changes on Facebook's end, FriendFormant is now dead.
  `,
  tags: ['Design', 'Facebook API', 'PHP',],
  images: [require('./images/1.jpg'), require('./images/2.jpg'), require('./images/3.jpg'),],
};



// WEBPACK FOOTER //
// ./src/data/works/friendformant/index.js